;(() => {
  if (customElements.get('product-swatches')) return

  window.SWATCHES_CACHE = window.SWATCHES_CACHE || {}
  let shouldUpdateLinkUrl = false,
    currentVariant = null,
    currentLashValue

  function getSelectedLengthFromDom() {
    try {
      const form = document.querySelector('form[action*="/cart/add"]')
      if (!form) return null
      const checked = form.querySelector('input[type="radio"][data-hook="product-option"]:checked')
      if (!checked) return null
      const name = (checked.getAttribute('name') || '').toLowerCase()
      if (!name.endsWith('length')) return null
      return checked.value || null
    } catch (e) {
      return null
    }
  }

  /** Match swatch link to current PDP using pathname only (?variant= breaks strict href equality). */
  function pathnameMatchesCurrentProduct(anchorHref) {
    if (!anchorHref) return false
    try {
      const locationRef = window.location
      const anchorPath = new URL(anchorHref, locationRef.origin).pathname.replace(/\/$/, '') || '/'
      const currentPath = (locationRef.pathname || '').replace(/\/$/, '') || '/'
      return anchorPath === currentPath
    } catch (e) {
      return false
    }
  }

  function applyLengthSelectionToHtml(html, targetLength) {
    if (!html || !targetLength) return html
    try {
      const temp = document.createElement('div')
      temp.innerHTML = html
      const radios = Array.from(temp.querySelectorAll('input[type="radio"][data-hook="product-option"]')).filter(
        (el) => {
          const name = (el.getAttribute('name') || '').toLowerCase()
          return name.endsWith('length')
        }
      )
      if (!radios.length) return html

      const target = radios.find((el) => el.value === targetLength)
      if (!target) return html
      if (target.disabled || target.classList.contains('disabled')) return html

      radios.forEach((el) => {
        el.checked = false
        el.removeAttribute('checked')
      })
      target.checked = true
      target.setAttribute('checked', 'checked')

      const first = temp.firstElementChild
      return first ? first.outerHTML : temp.innerHTML
    } catch (e) {
      return html
    }
  }

  function applyPurchaseTabToHtml(html, tab) {
    if (!html || (tab !== 'one-time' && tab !== 'subscription')) return html
    try {
      const temp = document.createElement('div')
      temp.innerHTML = html
      const root = temp.querySelector('.sub-purchase-tabs')
      if (window.lilacApplySubPurchaseTab && root) {
        window.lilacApplySubPurchaseTab(root, tab)
      } else if (root) {
        const dskRadios = root.querySelectorAll('[data-deluxe-purchase-option]')
        if (dskRadios.length) {
          dskRadios.forEach((radio) => {
            const selected = radio.value === tab
            radio.checked = selected
            if (selected) radio.setAttribute('checked', 'checked')
            else radio.removeAttribute('checked')
            radio.closest('[data-deluxe-purchase-card]')?.classList.toggle('is-active', selected)
          })
        } else {
          root.querySelectorAll('[data-tab]').forEach((button) => {
            button.classList.toggle('active', button.getAttribute('data-tab') === tab)
          })
          temp.querySelector('#subscription-content')?.classList.toggle('hidden', tab !== 'subscription')
          temp.querySelector('#one-time-content')?.classList.toggle('hidden', tab !== 'one-time')
        }
      }
      const first = temp.firstElementChild
      return first ? first.outerHTML : temp.innerHTML
    } catch (e) {
      return html
    }
  }

  class ProductSwatches extends HTMLElement {
    constructor() {
      super()
      this.form = this.closest('form')
      this.links = this.querySelectorAll('a')
      this.init()
      document.addEventListener('product:variant:change', this.saveSelectedVariant.bind(this))
    }

    init() {
      this.links.forEach((link) => {
        const url = window.location.href
        shouldUpdateLinkUrl = url.includes('3-pack')
        link.layout = this.getSwatchProductLayout(link.href)
        link.three_layout = this.getSwatchProductLayout(link.dataset.mapped || link.href)
      })
      this.setEventListeners()
      this.updateLinkUrl()
    }

    saveSelectedVariant(evt, data) {
      currentVariant = evt.detail.variant
      currentLashValue = document.querySelector('input[name="lash-radio-group"]:checked').value
    }

    updateLinkUrl() {
      if (shouldUpdateLinkUrl) {
        this.links.forEach((link) => {
          const mappedUrl = link.dataset.mapped
          if (mappedUrl) {
            link.href = mappedUrl
          }
        })
      }
      // Reconcile .on on <li> by pathname; strict href === location.href fails when
      // ?variant= is present (length changes) or when href is root-relative.
      this.querySelectorAll('li').forEach((li) => {
        const anchor = li.querySelector('a')
        if (!anchor) return
        const hrefAttr = anchor.getAttribute('href') || ''
        if (pathnameMatchesCurrentProduct(hrefAttr)) {
          li.classList.add('on')
        } else {
          li.classList.remove('on')
        }
      })
    }

    disconectedCallback() {
      this.links.forEach((link) => {
        link.removeEventListener('click', this.onClickHandler)
      })
    }

    setEventListeners() {
      this.onClickHandler = this.onClick.bind(this)
      this.links.forEach((link) => {
        link.addEventListener('click', this.onClickHandler)
      })
    }

    async onClick(event) {
      event.preventDefault()
      const link = event.currentTarget
      if (link.closest('li.on')) {
        return
      }
      const selectedLength = getSelectedLengthFromDom()
      if (selectedLength) {
        window.__lashBundleCurrentLength = selectedLength
      }
      const url = link.href
      const isMappedProductLink = link.dataset.mapped
      shouldUpdateLinkUrl = url.includes('3-pack')
      window.history.replaceState({}, '', url)

      // Store original position for restoration later
      let originalPosition = null

      // Scroll to top for desktop users (above 768px) before rendering new content
      if (window.innerWidth > 768) {
        const buyPanel = document.querySelector('[data-component="product/buy-panel"]')

        if (buyPanel) {
          // Remove sticky position first to prevent flicker
          originalPosition = buyPanel.style.position
          buyPanel.style.position = 'static'

          // Now scroll to top
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })

          // Wait for scroll to complete
          await new Promise((resolve) => setTimeout(resolve, 800))
        } else {
          // Fallback to page top if buy-panel not found
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
          // Wait for scroll to complete
          await new Promise((resolve) => setTimeout(resolve, 800))
        }
      }

      const productSection = this.closest('[data-main-product]')
      const reviewsSection = document.getElementById('stamped-main-widget')
      let newProductLayout, newReviewsLayout
      if (shouldUpdateLinkUrl) {
        ;[newProductLayout, newReviewsLayout] = await link.three_layout
      } else {
        ;[newProductLayout, newReviewsLayout] = await link.layout
      }

      // Preserve currently selected length by setting checked attr BEFORE injecting HTML.
      if (window.__lashBundleCurrentLength) {
        newProductLayout = applyLengthSelectionToHtml(newProductLayout, window.__lashBundleCurrentLength)
      }

      const savedTab = window.lilacGetSubPurchaseTab?.()
      if (savedTab) {
        newProductLayout = applyPurchaseTabToHtml(newProductLayout, savedTab)
      }

      productSection.outerHTML = newProductLayout
      reviewsSection.outerHTML = newReviewsLayout

      if (typeof window.syncSubscriberBenefitCols === 'function') {
        window.syncSubscriberBenefitCols()
      }

      // Restore sticky position after new content is rendered (desktop only)
      if (window.innerWidth > 768 && originalPosition) {
        requestAnimationFrame(() => {
          const newBuyPanel = document.querySelector('[data-component="product/buy-panel"]')
          if (newBuyPanel) {
            newBuyPanel.style.position = originalPosition
          }
        })
      }

      StampedFn.reloadUGC()
      window.setFormListeners()
    }

    async getSwatchProductLayout(url) {
      if (window.SWATCHES_CACHE[url]) return window.SWATCHES_CACHE[url]

      const response = await fetch(url)
      const html = await response.text()
      const newDom = new DOMParser().parseFromString(html, 'text/html')
      const productSection = newDom.querySelector('[data-main-product]')
      const reviewsSection = newDom.getElementById('stamped-main-widget')

      window.SWATCHES_CACHE[url] = [productSection.outerHTML, reviewsSection.outerHTML]
      return window.SWATCHES_CACHE[url]
    }
  }

  customElements.define('product-swatches', ProductSwatches)
})()
